export const RouteDeleteMerchflows_MerchflowId_StoresPogs = "/merchflows/:merchflowId/stores/pogs";

export interface PayloadDeleteMerchflows_MerchflowId_StoresPogs {
  store_pog_ids: number[];
}

export interface ResponseDeleteMerchflows_MerchflowId_StoresPogs {
  deleted_count: number;
  skipped_count: number;
  skipped_ids: number[];
}
